import { noop } from "../types.js";
import { createPromise, resolved } from "../promise.js";
import { now } from "./now.js";
import { isDefined } from "../types.js";
import { setTimeout } from "../window.js";
const MODULE = "bounty/timing/discarding-queue";
/**
 * @param {number} [ms]
 * @param {boolean} [immediate]
 * @param {boolean} [delayed]
 */
export const DiscardingQueue = (ms = 0, immediate, delayed) => {
    /**
     * @type {ReturnType<setTimeout>}
     */
    let timeout;
    /**
     * @type {Promise<unknown> | undefined}
     */
    let previousBusy;
    let rejectPrevious = noop;
    let resolvePrevious = noop;
    let previousTime = 0;
    let previousResolveTime = 0;
    let intermediate = isDefined(delayed);
    delayed ??= !immediate;
    const check = () => {
        let delta = previousTime + ms - now();
        if (previousBusy) {
            previousBusy.finally(check);
        }
        else if (delta > 0) {
            DEBUG: if (debounce.VERBOSE) {
                console.debug(performance.mark(`${debounce.VERBOSE}:overtime`).name, { delta });
            }
            timeout = setTimeout(check, delta);
        }
        else {
            DEBUG: if (debounce.VERBOSE) {
                console.debug(performance.measure(`${debounce.VERBOSE}:stop`, `${debounce.VERBOSE}:start`).name, {
                    delta,
                });
            }
            timeout = 0;
            if (delayed) {
                resolvePrevious();
            }
            else {
                rejectPrevious();
            }
        }
    };
    /**
     * @template T
     * @param {() => Promise<T> | T} callback
     * @returns {Promise<T>}
     */
    const debounce = (callback) => createPromise((resolve, reject) => {
        rejectPrevious();
        previousTime = now();
        if (!delayed && (previousBusy || (timeout && !intermediate))) {
            reject(debounce);
            return;
        }
        rejectPrevious = () => {
            rejectPrevious = noop;
            resolvePrevious = noop;
            reject(debounce);
        };
        resolvePrevious = () => {
            DEBUG: if (debounce.VERBOSE)
                console.warn(performance.mark(`${debounce.VERBOSE}:resolve`).name);
            previousResolveTime = now();
            rejectPrevious = noop;
            resolvePrevious = noop;
            const result = resolved(callback()).finally(() => {
                previousBusy = undefined;
                previousResolveTime = now();
                previousTime = now();
            });
            previousBusy = result;
            resolve(result);
        };
        if (!previousBusy) {
            if (intermediate && (timeout || !ms)) {
                if (previousResolveTime + ms <= now()) {
                    resolvePrevious();
                }
            }
            else if (immediate) {
                resolvePrevious();
            }
            else if (intermediate) {
                // Fake resolve for intermediate without immediate
                previousResolveTime = previousTime;
            }
        }
        if (!timeout) {
            if (!ms && previousBusy) {
                previousBusy.finally(check);
            }
            timeout = setTimeout(check, ms);
            DEBUG: if (debounce.VERBOSE) {
                console.debug(performance.mark(`${debounce.VERBOSE}:start`).name);
            }
        }
    });
    DEBUG: {
        debounce.VERBOSE = "";
        /**
         * @param {string} verbose
         */
        debounce.enableDebug = (verbose = "unknown") => {
            if (verbose) {
                debounce.VERBOSE = `${MODULE}(${verbose})`;
            }
            else {
                debounce.VERBOSE = "";
            }
        };
    }
    //debounce.cancel = () => debounce(noop).catch(noop);
    //debounce.flush = () => resolvePrevious();
    return debounce;
};
